import {
  CLEAR_LOGS,
  CLEAR_LOGS_FLAGS,
  ERROR_LOGS,
  LIST_LOGS_INIT,
  LIST_LOGS_SUCCESS
} from 'src/redux/actionTypes';

export const listLogsInit = (data: any) => ({
  type: LIST_LOGS_INIT,
  payload: data
});

export const listLogsSuccess = (data: any) => ({
  type: LIST_LOGS_SUCCESS,
  payload: data
});

export const errorLogs = (data: any) => ({
  type: ERROR_LOGS,
  payload: data
});

export const clearLogs = () => ({
  type: CLEAR_LOGS
});

export const clearLogsFlags = () => ({
  type: CLEAR_LOGS_FLAGS
});
